import React, { useEffect, useState } from "react";
import LoginForm from "./LoginForm";
import { BiLoaderCircle } from "react-icons/bi";
import { Link } from "react-router-dom";
import logo from "../../assets/Logo_Bakeli.png"
import ButtonBakeli from "../Utils/ButtonBakeli";

function LoginComponent() {
  const [loginUrl, setLoginUrl] = useState(null);

  useEffect(() => {
    getBakeliConnexionUrl()
  })

  const getBakeliConnexionUrl = () => {
    fetch(`https://api-work.bakeli.tech/api/bakeli/auth`, {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }).then((response) => response.json())
      .then((data) => {
        console.log({ data });
        setLoginUrl(data.url)
      })
      .catch((error) => console.error(error));
  }
  return (
    <div className="bg-white px-12 rounded-3xl shadow-lg py-7 max-lg:w-full max-lg:px-16 max-sm:px-8 max-xl:px-9">
      <div>
        <div className="flex items-center justify-center pt-4 px-2">
          <Link className={`flex items-center gap-4`} to={"/"}>
            <BiLoaderCircle
              className={`w-11 h-12 fill-current max-md:w-8 max-md:h-10 text-orange`}
            />
            <p className="text-4xl font-[500] text-nowrap text-vr">
              Bakeli Work
            </p>
          </Link>
        </div>
        <div className="mt-10">
          <p className="text-dsn px-4 text-center max-xl:px-0 text-3xl font-bold">
            Connectez - Vous
          </p>
        </div>
      </div>
      <LoginForm />
      <div className="flex flex-col items-center px-6">
        <div className="w-full flex justify-between items-center">
          <hr className="h-[0.5px] bg-blck/30 w-[40%]" />
          <span>OU</span>
          <hr className="h-[0.5px] bg-blck/30 w-[40%]" />
        </div>
        <ButtonBakeli logo={logo} link={loginUrl} text="Se connecter avec Bakeli" />
      </div>
    </div>
  );
}

export default LoginComponent;
